import { container, title } from "./material-kit-react.js";
import "./animation.css";

const landingPageStyle = {
  titlecontainer: {
    zIndex: "12",
    color: "#FFFFFF",
    padding: "150px 0",
    ...container,
  },
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    padding: "40px 0",
    ...container,
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
    fontSize: "3rem",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
    fontSize: "1.5rem",
    lineHeight: 1.4,
  },
  main: {
    background: "#1e243a",
    position: "relative",
    zIndex: "3",
    borderRadius: ".35rem",
    boxShadow: "0 12px 22px rgba(0, 0, 0, .53)",
  },
  mainRaised: {
    margin: "-60px 5% 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  mainpage: {
    background:
      "linear-gradient(    to bottom,    rgb(12, 14, 41),    rgb(49, 59, 97)  )",
  },
  bannerImage: {
    width: "100%",
    animation:
      "shake-vertical 10s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both",
    WebkitAnimation:
      "shake-vertical 10s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both",
  },
  bannerIntro: {
    marginBottom: "40px",
  },
  mybutton: {
    borderColor: "white",
    color: "white",
    marginBottom: "15px",
    marginLeft: "25px",
    marginRight: "25px",
    "&:hover": {
      background: "white",
      color: "black",
      marginBottom: "15px",
      marginLeft: "25px",
      marginRight: "25px",
    },
  },
  mybuttonr: {
    borderColor: "white",
    color: "white",
    marginBottom: "15px",
    marginLeft: "25px",
    marginRight: "25px",
    "&:hover": {
      background: "white",
      color: "black",
      marginBottom: "15px",
      marginLeft: "25px",
      marginRight: "25px",
    },
  },
};

export default landingPageStyle;
